import RemoteResourceRepository from './RemoteResourceRepository'
import {UniqueRecordError} from '../../utilities/errors'
import _ from 'lodash'

const handleErrors = Symbol('handleErrors')

/*
 * RemoteDomainRepository is a simple implementation of the RemoteRepository
*/
export default class RemoteDomainRepository extends RemoteResourceRepository {
  constructor () {
    super('domain')
  }

  [handleErrors] (e) {
    const {errors} = e
    if (errors) {
      const errorCodes = _.keyBy(errors, 'code')
      if (errorCodes.unique) {
        throw new UniqueRecordError(errorCodes.unique.detail)
      }
    }
    throw e
  }

  async createRecord (payload) {
    try {
      return await super.createRecord(payload)
    } catch (e) {
      return this[handleErrors](e)
    }
  }

  async updateRecord (payload) {
    try {
      return await super.updateRecord(payload)
    } catch (e) {
      return this[handleErrors](e)
    }
  }
}
